import { cva, type VariantProps } from "class-variance-authority";

export const toastVariants = cva(
  "border-2 rounded-lg p-4 !bg-gxe-bg-light !text-black dark:!bg-gxe-bg-light dark:!text-black",
  {
    variants: {
      type: {
        success: "!border-green-500",
        error: "!border-red-500",
        warning: "!border-yellow-500",
        info: "!border-blue-500",
      },
      size: {
        sm: "text-sm",
        md: "text-base",
      },
    },
    defaultVariants: {
      type: "info",
      size: "sm",
    },
  }
);

export const iconVariants = cva("h-5 w-5 flex-shrink-0", {
  variants: {
    type: {
      success: "text-green-500",
      error: "text-red-500",
      warning: "text-yellow-500",
      info: "text-blue-500",
    },
  },
  defaultVariants: {
    type: "info",
  },
});

export type ToastVariantProps = VariantProps<typeof toastVariants>;
export type IconVariantProps = VariantProps<typeof iconVariants>;
